"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2019 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/
// eslint-disable-next-line react/display-name
var _default = function _default() {
  return _react.default.createElement("svg", {
    height: "104px",
    version: "1.1",
    id: "Layer_1",
    viewBox: "0 0 103 103",
    xmlns: "http://www.w3.org/2000/svg",
    width: "auto"
  }, _react.default.createElement("g", {
    id: "notifications_bell_arrow_lg"
  }, _react.default.createElement("g", {
    id: "notifications_bell_arrow_lg-2"
  }, _react.default.createElement("path", {
    fill: "#B3B3B3",
    d: "M55.2,95.5C55.2,95.5,55.2,95.5,55.2,95.5c-2.9,0-5.7-1.1-7.7-3.2c-2.1-2.1-3.2-4.8-3.2-7.7 c0-0.8,0.7-1.5,1.5-1.5c0,0,0,0,0,0c0.8,0,1.5,0.7,1.5,1.5c0,2.1,0.8,4.1,2.3,5.6c1.5,1.5,3.5,2.3,5.6,2.3c0,0,0,0,0,0 c2.1,0,4.1-0.8,5.6-2.3c1.5-1.5,2.3-3.5,2.3-5.6c0-0.8,0.7-1.5,1.5-1.5c0,0,0,0,0,0c0.8,0,1.5,0.7,1.5,1.5c0,2.9-1.1,5.7-3.2,7.7 C60.9,94.4,58.1,95.5,55.2,95.5z"
  }), _react.default.createElement("path", {
    fill: "#B3B3B3",
    d: "M85.1,78.6c-0.1,0-0.3,0-0.4,0H26.5c-1.8,0-3.2-0.7-4-1.9c-0.7-1.2-0.7-2.7,0.1-4.1c0.5-1.1,1.1-2.2,1.7-3.3 c1.8-3.6,3.5-6.9,5-12.4c0.2-0.8,1-1.3,1.8-1.1c0.8,0.2,1.3,1,1.1,1.8c-1.5,5.8-3.4,9.4-5.2,13c-0.5,1.1-1.1,2.2-1.7,3.3 c-0.3,0.6-0.4,1-0.2,1.2c0.1,0.2,0.6,0.5,1.4,0.5h58.2c0.1,0,0.1,0,0.2,0c0.6,0.1,1.1-0.3,1.2-0.9c0-0.2,0-0.5-0.1-0.7 c0,0-0.1-0.1-0.1-0.1c-0.5-1-1-2.1-1.6-3.2c-3.2-6.4-7.2-14.3-7.3-27.1v-8.5c-0.1-7.8-5.6-23.9-21.7-23.9 c-10.3,0-19.1,8.2-21,19.4c-0.1,0.8-0.9,1.4-1.7,1.2c-0.8-0.1-1.4-0.9-1.2-1.7c2.1-12.7,12.1-22,23.9-22 c18.4,0,24.6,18.1,24.7,26.8v8.5c0,12,3.7,19.3,7,25.7c0.5,1.1,1.1,2.1,1.6,3.2c0.5,0.8,0.6,1.7,0.5,2.6 C88.8,77.1,87.1,78.6,85.1,78.6z"
  }), _react.default.createElement("path", {
    fill: "#B3B3B3",
    d: "M55.5,45.9H13.2c-0.8,0-1.5-0.7-1.5-1.5s0.7-1.5,1.5-1.5h42.3c0.8,0,1.5,0.7,1.5,1.5S56.3,45.9,55.5,45.9z"
  }), _react.default.createElement("path", {
    fill: "#B3B3B3",
    d: "M45.8,57.2c-0.4,0-0.8-0.2-1.1-0.5c-0.6-0.6-0.5-1.6,0.1-2.1L55,45.1l-10.2-9.5c-0.6-0.6-0.6-1.5-0.1-2.1 c0.6-0.6,1.5-0.6,2.1-0.1l10.6,9.8c0,0,0.1,0.1,0.1,0.1c0.9,1,0.9,2.5,0,3.5c0,0-0.1,0.1-0.1,0.1l-10.6,9.8 C46.5,57.1,46.1,57.2,45.8,57.2z"
  }))));
};

exports.default = _default;